import React from "react";
import Badge from "@mui/material/Badge";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import CircularProgress from "@mui/material/CircularProgress";
import Menu from "@mui/material/Menu";

import COLOR from "lib/colors";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

import ReactionPicker from "./ReactionPicker";

type Props = {
    side: "left" | "right";
    reaction: Maybe<Reaction>;
    onChange?: ((value: Maybe<Reaction>) => void) | undefined;
    isLoading?: boolean;
};

const ReactionLoader = () => (
    <div className="prel">
        <CircularProgress variant="indeterminate" size={16} sx={{ color: COLOR["slate-grey"] }} />
    </div>
);

const ReactionBadge = ({ side = "left", reaction, onChange, isLoading = false }: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }; // simple badge if no onChange
    const handleClose = () => {
        setAnchorEl(null);
    };
    if (!onChange) {
        if (!reaction) {
            return null;
        }
        return (
            <Badge
                className={`ws-conversation-bubble__reaction ws-conversation-bubble__reaction--${side}`}
            >
                {reaction.emoji}
            </Badge>
        );
    }
    return (
        <>
            <Badge
                id="reaction-button"
                className={`ws-conversation-bubble__reaction ws-conversation-bubble__reaction-picker ws-conversation-bubble__reaction--${side}`}
                onClick={handleClick}
                aria-controls={open ? "reaction-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
            >
                {isLoading ? (
                    <ReactionLoader />
                ) : (
                    reaction?.emoji || (
                        <InsertEmoticonIcon className="ws-conversation-bubble__reaction--empty" />
                    )
                )}
            </Badge>
            <Menu
                id="reaction-menu"
                className="ws-reaction-picker__menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "reaction-button",
                }}
            >
                <ReactionPicker
                    reaction={reaction}
                    onChange={(val) => {
                        if (onChange) onChange(val);
                        handleClose(); // force close the tooltip
                    }}
                    disabled={isLoading}
                />
            </Menu>
        </>
    );
};

export default ReactionBadge;
